import { render, staticRenderFns } from "./inviteFriends.vue?vue&type=template&id=093828fc&scoped=true&"
import script from "./inviteFriends.vue?vue&type=script&lang=js&"
export * from "./inviteFriends.vue?vue&type=script&lang=js&"
import style0 from "./inviteFriends.vue?vue&type=style&index=0&id=093828fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093828fc",
  null
  
)

export default component.exports